export default __webpack_public_path__ + "static/media/yellow_line.929c660a.svg";